import React, { Component } from 'react';
import classes from './FirstScreen.css';
import bg from '../../img/scene.png';

class FirstScreen extends Component {
  render() {
    return (
      <div className={[classes.FirstScreen, `${this.props.isShown && classes.Show}`].join(' ')}>
        <div
          className={classes.BackgroundContainer}
          style={{
            backgroundImage:`url("${bg}")`,
            backgroundSize: 'contain',
          }}
        >
          <div className={classes.CentralButtonContainer}>
            <input type="file" id="loadAvatarFS" onChange={(e) => this.props.onFileInputChange(e)}/>
            <label className={classes.CentralButton} htmlFor="loadAvatarFS">Загрузить фото</label>
          </div>
        </div>
      </div>
    );
  }
}
export default FirstScreen;



// WEBPACK FOOTER //
// ./src/components/FirstScreen/FirstScreen.js